import type { FabricObject } from '@meitu/whee-infinite-canvas';
import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { WithImmer } from './immer.d';

interface FabricElObject {
  [key: string]: FabricObject[];
}

interface ShareState {
  originItems: any[];
  stepOriginItems: any[];
  messages: any[][];
  sliderValue: number;
  fabricElObject: FabricElObject;
  shareCoverUrl: string;
  shareFlowUrl: string;
  /** 团队会话分享落地页（拼接 short_link） */
  shareTeamUrl: string;
}

const shareSlice: StateCreator<ShareState, [
  ['zustand/immer', never],
]> = () => ({
  originItems: [],
  stepOriginItems: [],
  messages: [],
  fabricElObject: {},
  sliderValue: 0,
  shareCoverUrl: '',
  shareFlowUrl: '',
  shareTeamUrl: '',
});

const useShareStote: UseBoundStore<WithImmer<StoreApi<ShareState>>> = create<ShareState>()(immer(shareSlice));
export default useShareStote;

/**
 * 缓存分享事件流的原始数据
 * @export
 * @param {*} items
 */
export function setOriginItems(items: any) {
  useShareStote.setState(() => ({ originItems: items }));
}

/**
 * 缓存分享事件流的分步数据
 *
 * @export
 * @param {*} items
 */
export function pushStepOriginItems(item: any) {
  useShareStote.setState((state) => ({
    stepOriginItems: [...state.stepOriginItems, item],
  }));
}

/**
 * 更新分享事件流的分步数据
 *
 * @export
 * @param {*} item
 * @param {number} index
 */
export function updateStepOriginItems(item: any, index: number) {
  useShareStote.setState((state) => {
    // eslint-disable-next-line no-param-reassign
    state.stepOriginItems[index] = item;
  });
}

/**
 * 设置分步数据
 *
 * @export
 */
export function setStepOriginItems(items: any[]) {
  useShareStote.setState(() => ({
    stepOriginItems: items,
  }));
}

/**
 * 缓存事件流的处理后用于渲染的数据
 *
 * @export
 * @param {*} ms
 */
export function setMessages(ms: any) {
  useShareStote.setState(() => ({ messages: ms }));
}

/**
 * 缓存滑动条的值
 *
 * @export
 * @param {number} val
 */
export function setSliderValue(val: number) {
  useShareStote.setState(() => ({ sliderValue: val }));
}

/**
 * 缓存画布中所有对象的数据
 *
 * @export
 * @param {FabricElObject} data
 */
export function setFabricElObject(data: FabricElObject) {
  useShareStote.setState(() => ({ fabricElObject: data }));
}

/**
 * 设置分享封面页链接
 *
 * @export
 * @param {string} url
 */
export function setShareCoverUrl(url?: string) {
  if (!url) return;
  useShareStote.setState(() => ({ shareCoverUrl: url }));
}

/**
 * 事件流分享链接
 *
 * @export
 * @param {string} url
 */
export function setShareFlowUrl(url?: string) {
  if (!url) return;
  useShareStote.setState(() => ({ shareFlowUrl: url }));
}

/**
 * 团队会话分享落地页链接
 *
 * @export
 * @param {string} url
 */
export function setShareTeamUrl(url?: string) {
  if (!url) return;
  useShareStote.setState(() => ({ shareTeamUrl: url }));
}
